import { css } from "styled-components";

export const amazingYellow = css`
  background: rgba(255, 204, 0, 0.2);
  background: linear-gradient(
    to bottom,
    var(--dui-color-yellow-500) 0%,
    rgba(255, 204, 0, 0.2) 100%
  );
`;

export const amazingYellowHeavy = css`
  background: rgba(255, 204, 0, 0.2);
  background: linear-gradient(
    to bottom,
    var(--dui-color-yellow-500) 50%,
    rgba(255, 204, 0, 0.2) 100%
  );
`;
